import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useAuth } from '@/lib/auth'
import { useI18n } from '@/lib/i18n'
import { signInUrlReturningTo } from '@/lib/return-target'

export function InlineRegistration({
  returnTarget,
  onRegistered,
  onCancel,
}: {
  returnTarget: string
  onRegistered: () => void | Promise<void>
  onCancel?: () => void
}) {
  const { t } = useI18n()
  const { registerAccount, isLoading } = useAuth()
  const [email, setEmail] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    const { ok } = await registerAccount({ email, password, username })
    if (ok)
      await onRegistered()
  }

  return (
    <form
      className="space-y-3"
      data-testid="inline-registration"
      onSubmit={(event) => {
        submit(event).catch(() => {})
      }}
    >
      <div className="space-y-1">
        <Label htmlFor="inline-email">{t('auth.signUp.email')}</Label>
        <Input
          id="inline-email"
          type="email"
          required
          autoComplete="email"
          data-testid="inline-registration-email"
          value={email}
          onChange={event => setEmail(event.target.value)}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="inline-username">{t('auth.signUp.username')}</Label>
        <Input
          id="inline-username"
          required
          autoComplete="username"
          data-testid="inline-registration-username"
          value={username}
          onChange={event => setUsername(event.target.value)}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="inline-password">{t('auth.signUp.password')}</Label>
        <Input
          id="inline-password"
          type="password"
          required
          autoComplete="new-password"
          data-testid="inline-registration-password"
          value={password}
          onChange={event => setPassword(event.target.value)}
        />
      </div>
      <div className="flex items-center gap-2">
        <Button
          type="submit"
          disabled={isLoading}
          data-testid="inline-registration-submit"
        >
          {t('auth.signUp.button')}
        </Button>
        {onCancel && (
          <Button
            type="button"
            variant="ghost"
            data-testid="inline-registration-cancel"
            onClick={onCancel}
          >
            {t('common.cancel')}
          </Button>
        )}
      </div>
      {
      }
      <p className="text-xs text-muted-foreground">
        <Link
          className="font-medium underline hover:text-foreground"
          data-testid="inline-registration-signin"
          to={signInUrlReturningTo(returnTarget)}
        >
          {t('auth.signUp.signInNow')}
        </Link>
      </p>
    </form>
  )
}
